/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuthAppClientResponse } from './oAuthAppClientResponse';
import { OAuthAppClientCredentials } from './oAuthAppClientCredentials';


export interface OAuthAppInfo { 
    native_app?: OAuthAppClientResponse;
    server_app?: OAuthAppClientCredentials;
}

